import { Axios } from 'src/class/Axios.js';
import axios from 'axios';

const mixinPolitics = {
  data() {
    return {
      showPolitics: false,
      policy: null,
      isLoading: false,
    };
  },
  methods: {
    /**
 * realizamos una peticion axios al back para validar si el usuario
 * confirmo la politica que se esta mostrando (la mas actual)
 * si la confirmo, pasa directo al home en caso contrario
 * se abre el modal de politicas.
 */
    validatePolitics() {
      if (this.policy) {
        const data = {
          user_id: this.$store.state.auth.user.id,
          policy_id: this.policy.id,
        };
        axios
          .post('policyversions/validateuser', data)
          .then((response) => {
            if (response.data.data) {
              this.auth();
            } else {
              this.isLoading = false;
              this.showPolitics = true;
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.auth();
          });
      } else {
        this.auth();
      }
    },
    /**
      * realizamos una peticion axios al back para guardar un
      * registro donde asociamos al usuario y a la politica que acaba de confirmar
      * para que no le vuelva a aparecer, luego lo enviamos al home
      */
    confirm() {
      const data = {
        user_id: this.$store.state.auth.user.id,
        policy_id: this.policy.id,
      };
      axios
        .post('policyversions/user', data)
        .then(() => {
          this.showPolitics = false;
          this.isLoading = true;
          this.auth();
        })
        .catch((error) => {
          this.isLoading = true;
          SweetAlert.warning(error.response.data.message);
        });
    },
    /**
 * esta funcion lleva al usuario al home
 */
    auth(response) {
      this.isLoading = true;
      this.$router.push('/').catch(() => {
        if (response.data.code || response.data.code === 1) {
          this.passRequestEmail({
            login: response.data.data,
            password_temporary: true,
          });
          this.isLoading = false;
        }
      });
    },

  },
};

export default mixinPolitics;
